var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column justify-center align-center elevetion-5"},[_c('v-img',{attrs:{"src":_vm.icon,"max-height":"30","contain":""}}),_c('div',{staticClass:"text-caption"},[_vm._v(" "+_vm._s(_vm.label || '')+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }